module.exports = "<div [ngClass]=\"{'connect-open': showConnect()}\">\n    <app-connect *ngIf=\"showConnect()\"></app-connect>\n    <app-header *ngIf=\"currentRoute !== '/rosetta-catalog'\"></app-header>\n    <div class=\"router-wrap\">\n        <router-outlet></router-outlet>\n    </div>\n    <app-footer *ngIf=\"currentRoute !== '/rosetta-catalog'\"></app-footer>\n</div>"


//////////////////
// WEBPACK FOOTER
// /tmp/build_0264da94/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main